export const mutations = {
  STORE_CONSIGNEES(state, consignees) {
    state.consignees = consignees;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/mutations.js